import { useEffect, useMemo, useSyncExternalStore } from 'react'

import type { ChatAttachmentApi } from './attachments'
import { createAttachmentUploads } from './attachmentUploads'

/**
 * Composer uploads bound to one transport. A new `api` (another workspace's
 * app token) starts a fresh set and discards the previous one's unsent files,
 * so pass a memoised `api`.
 */
export const useChatAttachments = (api: ChatAttachmentApi) => {
  const uploads = useMemo(() => createAttachmentUploads(api), [api])

  useEffect(() => () => uploads.discardUnsent(), [uploads])

  const items = useSyncExternalStore(uploads.subscribe, uploads.getItems)

  return {
    items,
    add: uploads.add,
    remove: uploads.remove,
    retry: uploads.retry,
    release: uploads.release,
    discardAll: uploads.discardAll,
    isUploading: items.some((item) => item.status === 'uploading')
  }
}
